import React from "react";
import './branding.css';
import BlankPage from "../../blankpage/BlankPage";

function BrandingList() {
  
    return (
      <section>
        <div class="container">
          <BlankPage />
          <div class="tiles-grid">
            
          </div>

        </div>
      </section>
    );
  }

export default BrandingList;